import React from 'react'

// `sortable` opts a table into sorting: pass the headers that can be sorted,
// plus the active sort and a click handler. Tables that omit it render exactly
// as before.
function TableHeader({ headers, sortable = [], sort, onSort }) {
  const indicator = (header) => {
    if (!sortable.includes(header)) return null
    if (sort?.key !== header) return <span className='tw-opacity-30'>↕</span>
    return <span>{sort.direction === 'asc' ? '↑' : '↓'}</span>
  }

  return (
    <div class='tw-px-[10px] tw-hidden md:tw-flex tw-border-b-[1px] tw-border-[#E7E7E7] tw-pb-[10px]'>
      {headers.map((header) => (
        <div
          key={header}
          onClick={() => sortable.includes(header) && onSort && onSort(header)}
          class={`tw-text-[12px] tw-w-2/12 tw-flex tw-gap-[3px] ${
            sortable.includes(header) ? 'tw-cursor-pointer' : ''
          }`}
        >
          {header}
          {indicator(header)}
        </div>
      ))}
    </div>
  )
}

export default TableHeader
